module.exports = __webpack_public_path__ + "img/default.e9da5703.jpg";